import browserHistory from '../history';
import _ from 'lodash';
import UserManager from './UserManager';
import queryString from 'query-string';
import { matchPath } from 'react-router';
import GlobalConst from '../utils/GlobalConst';
import PubSub from 'pubsub-js';

export default {

	goBack() {
		browserHistory.goBack();
	},

	goBackWithPath(path=null) {
		if (document.referrer!='') this.goTo(path);
		else this.goBack();
	},

	currentQuery() {
		return queryString.parse(browserHistory.location.search);
	},

	getQueryKeyValue(key, url = window.location.href) {
		const name = key.replace(/[[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2]);
	},

	removeFromQuery(keys) {
		if (!_.isEmpty(keys)) {
			browserHistory.replace({
				pathname: this.currentPath(),
				query: queryString.stringify(_.omit(this.currentQuery(), keys))
			});
		}
	},

	currentPath() {
		return browserHistory.location.pathname;
	},

	currentHost() {
		return browserHistory.location.host;
	},

	currentOrigin() {
		return window.location.origin;
	},

	currentPathMatches(path) {
		const match = matchPath(this.currentPath(), {path});
		return !_.isNil(match);
	},

	goTo(path, query = null) {
		if(!query) {
			browserHistory.push(path);
		} else {
			browserHistory.push({pathname: path, search: queryString.stringify(query)});
		}
		PubSub.publish(GlobalConst.SET_BREADCRUMBS_MSG)
	},

	goToExternal(path, newWindow=false) {
		if (!newWindow) {
			window.open(path);
		} else {
			window.open(path, '_blank');
		}
	},

	replaceQuery(newQuery) {
		browserHistory.replace({
			pathname: this.currentPath(),
			search: queryString.stringify(newQuery)
		})
	},

	pushQuery(newQuery) {
		browserHistory.push({
			pathname: this.currentPath(),
			search: queryString.stringify(newQuery)
		});
	},

	replaceRawQuery(newQuery) {
		browserHistory.replace({
			pathname: this.currentPath(),
			search: newQuery
		})
	},

	goToUserCabinet() {
		this.goTo('/my_profile');
	},

	goToWelcomePage() {
		this.goTo('/welcome');
	},

	goToErrorPage() {
		this.goTo('/maintenance');
	},

	goToUserList() {
		this.goTo('/users');
	},

	goToLogin(checkFrom = false, error = null) {
		const query = {};
		if(checkFrom){
			query.from = location.pathname + location.search;
		}
		if(error){
			query.error= error;
		}
		this.goTo('/login', query);
	},

	goToDefaultRoute() {
		if (UserManager.user.isActive) return this.goTo(this.takeHome());
		else if (!UserManager.user.isActive && UserManager.user.email) return this.goToWelcomePage();
		else if (!UserManager.isAuthorized) return this.goToLogin();
	},

	takeHome() {
		return '/home';
	},

	internalUserPermissionsPageLink(userID){
		return `/users/permissions/${userID}/`;
	},

	internalRolePermissionsPageLink(roleID){
		return `/roles/permissions/${roleID}/`;
	},

	accessDeniedPageURL() {
		return '/access_denied';
	},

	setTitle(title) {
		document.title = title ? `${title} | Activate IQ` : 'Activate IQ';
	}

};

